import React from "react";
import { Link } from "react-router-dom";
import { news } from "../data";

const LatestNews = () => {
	const latestNews = news.pages[0].newsList.slice(0, 6);

	return (
		<section className="py-16 bg-gray-50">
			<div className="container mx-auto px-4">
				<div className="flex justify-between items-center mb-10">
					<div>
						<h2 className="text-3xl font-bold text-blue-900">Latest News</h2>
						<p className="text-gray-600">Top stories from around the world</p>
					</div>
					<Link to="/news" className="text-blue-600 hover:text-blue-800 font-semibold flex items-center gap-1">
						View All →
					</Link>
				</div>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
					{latestNews.map((item, index) => (
						<div key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300">
							<div className="h-40 bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center text-5xl">
								{item.icon}
							</div>
							<div className="p-4">
								<span className="text-xs font-bold text-blue-600 bg-blue-50 px-2 py-1 rounded">
									{item.category}
								</span>
								<h3 className="font-bold text-md mt-2 text-blue-900 line-clamp-2">
									{item.title}
								</h3>
								<div className="flex justify-between text-xs text-gray-500 mt-2">
									<span>🕐 {item.time}</span>
									<span>👁️ {item.views}</span>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default LatestNews;